import { TransmissionSystemOperatorResource } from 'app/_resources/transmission-system-operator.resource';
import { Growl } from 'angular/custom/services/growl.service';
import { AuthService } from 'app/_services/auth.service';
import { ErrorHandler } from 'app/_services/error-handler.factory';
import * as angular from 'angular';

class UnderlyingPriceSettingsComponentCtrl implements ng.IController {
    private settings: TsoSecondarySettingsDto;
    private loggedInUser: LoginResult;
    private savingInProgress: boolean = false;
    private rememberSelectionPossibilityForUnderlyingSurcharge: SelectionPossibility;

    constructor(
        private TransmissionSystemOperator: TransmissionSystemOperatorResource,
        private growl: Growl,
        private authService: AuthService,
        private errorHandler: ErrorHandler
    ) {}

    $onInit(): void {
        this.authService.userLoginPromise.promise.then(
            (res) => (this.loggedInUser = res)
        );
        this.rememberSelectionPossibilityForUnderlyingSurcharge =
            this.settings.selectionPossibilityForUnderlyingSurcharge;
    }

    saveSupportToPreFillPriceFromUnderlyingDeal(): void {
        this.savingInProgress = true;

        this.TransmissionSystemOperator.saveSupportToPreFillPriceFromUnderlyingDeal(
            { id: this.loggedInUser.referenceId },
            this.settings.prefillUnderlyingPrice,
            this.successHandler.bind(this),
            (err: ng.IHttpPromiseCallbackArg<RestError>) => {
                this.errorHandler(err);
                this.settings.prefillUnderlyingPrice =
                    !this.settings.prefillUnderlyingPrice;
            }
        ).$promise.finally(this.finallyHandler.bind(this));
    }

    saveSupportToChangePriceOfUnderlyingDeal(): void {
        this.savingInProgress = true;

        this.TransmissionSystemOperator.saveSupportToChangePriceOfUnderlyingDeal(
            { id: this.loggedInUser.referenceId },
            this.settings.allowManualEntryOfUnderlyingPrice,
            this.successHandler.bind(this),
            (err: ng.IHttpPromiseCallbackArg<RestError>) => {
                this.errorHandler(err);
                this.settings.allowManualEntryOfUnderlyingPrice =
                    !this.settings.allowManualEntryOfUnderlyingPrice;
            }
        ).$promise.finally(this.finallyHandler.bind(this));
    }

    saveSurchargeSelectionPossibility(): void {
        this.savingInProgress = true;

        this.TransmissionSystemOperator.saveSurchargeSelectionPossibility(
            { id: this.loggedInUser.referenceId },
            {
                selectionPossibility:
                    this.settings.selectionPossibilityForUnderlyingSurcharge
            },
            this.successHandler.bind(this),
            (err: ng.IHttpPromiseCallbackArg<RestError>) => {
                this.errorHandler(err);
                this.settings.selectionPossibilityForUnderlyingSurcharge =
                    this.rememberSelectionPossibilityForUnderlyingSurcharge;
            }
        ).$promise.finally(this.finallyHandler.bind(this));
    }

    hideRegulatedTariffForUnderlyingDeals(): void {
        this.savingInProgress = true;

        this.TransmissionSystemOperator.hideRegulatedTariffForUnderlyingDeals(
            { id: this.loggedInUser.referenceId },
            this.settings.hideRegulatedTariff,
            this.successHandler.bind(this),
            (err: ng.IHttpPromiseCallbackArg<RestError>) => {
                this.errorHandler(err);
                this.settings.hideRegulatedTariff =
                    !this.settings.hideRegulatedTariff;
            }
        ).$promise.finally(this.finallyHandler.bind(this));
    }

    allowUpdateOfRegulatedTariffForUnderlyingDeals(): void {
        this.savingInProgress = true;

        this.TransmissionSystemOperator.allowUpdateOfRegulatedTariffForUnderlyingDeals(
            { id: this.loggedInUser.referenceId },
            this.settings.allowUpdateOfRegulatedTariff,
            this.successHandler.bind(this),
            (err: ng.IHttpPromiseCallbackArg<RestError>) => {
                this.errorHandler(err);
                this.settings.allowUpdateOfRegulatedTariff =
                    !this.settings.allowUpdateOfRegulatedTariff;
            }
        ).$promise.finally(this.finallyHandler.bind(this));
    }

    private successHandler() {
        this.growl.show('Successfully saved.', 'success', { delay: 2000 });
    }

    private finallyHandler(): void {
        this.savingInProgress = false;
    }
}

angular.module('app').component('pkpUnderlyingPriceSettings', {
    controller: UnderlyingPriceSettingsComponentCtrl,
    template:
        require('app/operator-settings-secondary-market/underlying-price-settings.component.html'),
    bindings: {
        settings: '='
    }
});
